// client/src/components/AnnouncementsModal.tsx

import React from 'react';
import { createPortal } from 'react-dom';
import { useT } from '../lib/i18n';
import type { Announcement } from '../hooks/useAnnouncements';

interface Props {
  announcements: Announcement[];
  onDismiss: () => void;
}

const TYPE_CONFIG = {
  fix:         { en: 'Fix',         es: 'Corrección', cls: 'ann-badge ann-badge--fix' },
  new:         { en: 'New',         es: 'Nuevo',      cls: 'ann-badge ann-badge--new' },
  improvement: { en: 'Improvement', es: 'Mejora',     cls: 'ann-badge ann-badge--improvement' },
};

export function AnnouncementsModal({ announcements, onDismiss }: Props) {
  const { t, lang } = useT();

  if (announcements.length === 0) return null;

  const content = (
    <div
      className="optin-modal-backdrop"
      onClick={e => { if (e.target === e.currentTarget) onDismiss(); }}
    >
      <div className="optin-modal" role="dialog" aria-modal="true">

        <div className="optin-modal-header">
          <span className="optin-modal-icon" aria-hidden>◈</span>
          <h2 className="optin-modal-title">{t('announcements.title')}</h2>
        </div>

        <div className="optin-modal-body">
          {announcements.map((ann, idx) => (
            <div key={ann.id} className={idx > 0 ? 'ann-block ann-block--sep' : 'ann-block'}>
              <p className="ann-block-title">
                {lang === 'es' ? ann.title_es : ann.title_en}
              </p>
              <ul className="ann-items">
                {ann.items.map((item, i) => {
                  const cfg = TYPE_CONFIG[item.type] ?? TYPE_CONFIG.improvement;
                  return (
                    <li key={i} className="ann-item">
                      <span className={cfg.cls}>
                        {lang === 'es' ? cfg.es : cfg.en}
                      </span>
                      <span className="ann-item-text">
                        {lang === 'es' ? item.es : item.en}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <div className="optin-modal-footer" style={{ justifyContent: 'flex-end' }}>
          <button className="btn btn-primary" onClick={onDismiss}>
            {t('announcements.cta')}
          </button>
        </div>

      </div>
    </div>
  );

  return createPortal(content, document.body);
}
